import PropTypes from 'prop-types';

export const SelectValuePropTypes = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
]);

export const SelectOptionPropTypes = PropTypes.shape({
  label: PropTypes.string,
  value: SelectValuePropTypes,
});

export const SelectTabPropTypes = PropTypes.shape({
  text: PropTypes.string,
  value: PropTypes.string,
});

export const FormikPropTypes = PropTypes.shape({
  values: PropTypes.objectOf(PropTypes.any).isRequired, // eslint-disable-line react/forbid-prop-types
  errors: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.objectOf(PropTypes.string).isRequired,
  ])),
  touched: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.bool.isRequired,
    PropTypes.objectOf(PropTypes.bool).isRequired,
  ])),
  isSubmitting: PropTypes.bool.isRequired,
  isValidating: PropTypes.bool.isRequired,
  submitCount: PropTypes.number.isRequired,
  initialValues: PropTypes.objectOf(PropTypes.any).isRequired, // eslint-disable-line react/forbid-prop-types
  initialErrors: PropTypes.objectOf(PropTypes.string).isRequired,
  initialTouched: PropTypes.objectOf(PropTypes.bool).isRequired,
  isValid: PropTypes.bool.isRequired,
  dirty: PropTypes.bool.isRequired,
  validateOnBlur: PropTypes.bool.isRequired,
  validateOnChange: PropTypes.bool.isRequired,
  validateOnMount: PropTypes.bool.isRequired,
});

export const FormSchemaPropTypes = PropTypes.arrayOf(PropTypes.shape({
  name: PropTypes.string.isRequired,
  component: PropTypes.elementType.isRequired,
  meta: PropTypes.shape({
    label: PropTypes.string,
    optionsKey: PropTypes.string,
  }),
  options: PropTypes.shape({
    yupType: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    validationRules: PropTypes.arrayOf(PropTypes.func),
  }),
  additionalProps: PropTypes.oneOfType([
    PropTypes.objectOf(PropTypes.any),
    PropTypes.func,
  ]),
}));
